module.exports = __webpack_public_path__ + "img/traffic-light-green.6d8b33c9.svg";